import { MISSION_MAP_DRAWING_MODES, MISSION_PAGE_MODES } from 'utils/constants'

/**
 * Named reasons that suppress auto-opening the header notification sandwich.
 * Inbox + bell badge still update. Add a new key here, then call
 * `useSuppressNotificationSandwich(active, NOTIFICATION_SANDWICH_SUPPRESS.YOUR_KEY)`
 * from the screen/modal that needs quiet UI.
 */
export const NOTIFICATION_SANDWICH_SUPPRESS = {
  MISSION_MAP_EDIT: 'mission-map-edit',
  RECORDED_ROUTE_EDIT: 'recorded-route-edit',
  ROBOT_MAP_EDIT: 'robot-map-edit',
  SET_POSE: 'set-pose',
  STATION_GEO: 'station-geo',
  MAINTENANCE_POINT_GEO: 'maintenance-point-geo',
  FACILITY_GEO: 'facility-geo',
  MAP_RECORDING: 'map-recording',
  SERVICE_CALIB_MAP: 'service-calib-map',
  TASK_SETTINGS_MODAL: 'task-settings-modal',
  /** Applied automatically when snooze is active (no hook needed). */
  SNOOZE: 'snooze',
  /** Applied automatically during quiet hours (no hook needed). */
  QUIET_HOURS: 'quiet-hours',
} as const

export type NotificationSandwichSuppressReason =
  (typeof NOTIFICATION_SANDWICH_SUPPRESS)[keyof typeof NOTIFICATION_SANDWICH_SUPPRESS]

/** Mission page: drawing/editing geometry or placing points on the map. */
export function isMissionMapPointerActive(
  pageMode: MISSION_PAGE_MODES,
  mapMode: MISSION_MAP_DRAWING_MODES
): boolean {
  return pageMode !== MISSION_PAGE_MODES.VIEW_ZONES || mapMode !== MISSION_MAP_DRAWING_MODES.VIEW_ZONES
}
